export default function getResource(label, vars = []) {
    const resources = {
        addToBasket: 'Ajouter au panier',
        addAllToBasket: 'Tout ajouter au panier',
        addedToBasket: 'Ajouté au panier',
        add: 'Ajouter',
        added: 'Ajouté',
        remove: 'Supprimer',
        exclusive: 'Exclusivement',
        storePickup: 'pour le ramassage en magasin',
        standardShipping: 'À expédier',
        sameDayDelivery: 'pour la livraison le jour même',
        fastDelivery: 'pour la livraison rapide',
        sameDayCustomDelivery: `pour ${vars[0]}`,
        autoReplenish: `Livrer chaque ${vars[0]}`,
        alreadyAddedKohls: 'Déjà ajouté au panier',
        SameDay: 'de la livraison le jour même',
        FastDelivery: 'de la livraison rapide',
        Pickup: 'du ramassage',
        ShipToHome: 'des articles à expédier',
        itemShip: 'Désolé, cet article n’est pas offert dans votre pays.',
        inBasket: 'dans le panier',
        restock: 'Réapprovisionner',
        // RBF-2 (BEP-1462) / AT-R2-07: English placeholders -- SDL team translates weekly (see BEP-1461)
        rewardBundlingNotEnoughPointsTitle: 'Not Enough Points to Redeem',
        rewardBundlingNotEnoughPointsBody: `You have ${vars[0]} points left. Earn more points to redeem.`,
        rewardBundlingNotEnoughPointsAction: 'Got It'
    };
    return resources[label];
}
